export const tokens = {
  primary: '#00488d',
  primaryContainer: '#005fb8',
  onPrimary: '#ffffff',
  onPrimaryContainer: '#cadcff',
  secondary: '#506073',
  secondaryContainer: '#d0e1f8',
  onSurface: '#191c1e',
  onSurfaceVariant: '#424752',
  outlineVariant: '#c2c6d4',
  surface: '#f7f9fb',
  surfaceContainerLow: '#f2f4f6',
  surfaceContainerLowest: '#ffffff',
  surfaceContainer: '#eceef0',
  emerald: '#22c55e',
} as const
